export const CONTACT_US_EMAIL = 'support@flowcode.com'
export const CONTACT_SALES_EMAIL = 'partner@flowcode.com'
export const CONTACT_PUBLIC_RELATIONS_EMAIL = 'press@flowcode.com'
